import * as React from 'react';
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import ToggleButtonGroup, {
  toggleButtonGroupClasses,
} from '@mui/material/ToggleButtonGroup';

const StyledToggleButtonGroup = styled(ToggleButtonGroup)(({ theme }) => ({
  [`& .${toggleButtonGroupClasses.grouped}`]: {
    margin: theme.spacing(0.5),
    border: 0,
    borderRadius: theme.shape.borderRadius,
    [`&.${toggleButtonGroupClasses.disabled}`]: {
      border: 0,
    },
  },
  [`& .${toggleButtonGroupClasses.middleButton},& .${toggleButtonGroupClasses.lastButton}`]:
    {
      marginLeft: -1,
      borderLeft: '1px solid transparent',
    },
}));

const CustomToggleButtonGroup = ({
  value,
  onChange,
  children,
  fullWidth,
  ...props
}) => {
  return (
    <Paper
      elevation={0}
      sx={{
        display: fullWidth ? 'flex' : 'inline-flex',
        border: (theme) => `1px solid ${theme.palette.divider}`,
        flexWrap: 'wrap',
      }}
    >
      <StyledToggleButtonGroup
        exclusive
        fullWidth={fullWidth}
        value={value}
        onChange={onChange}
        {...props}
      >
        {children}
      </StyledToggleButtonGroup>
    </Paper>
  );
};

export default CustomToggleButtonGroup;

export { default as ToggleButton } from '@mui/material/ToggleButton';
